export default __webpack_public_path__ + "media/images/front/snsBnr/pc_sns_tab-f547f8b4d65183ffac20dd69b86af312.png";